<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--alert box-->
        <v-alert text dense color="teal" icon="mdi-clock-fast" border="left" v-if="userStatusmsg">
          <div v-for="(resp, i) in userResponse" :key="i">
            {{ resp }}
          </div>
        </v-alert>
        <!--alert box end-->

        <!---datatable -->
        <v-data-table :headers="headers" :items="users" :search="search" sort-by="temporary_no" class="elevation-1">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>USER</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-btn color="primary" dark class="mb-2" to="/user/add">
                NEW USER
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editUser(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
        <!---datatable end-->
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../router";

export default {
  name: "User",
  data: () => ({
    search: "",
    headers: [
      {
        text: "EMPLOYEE CODE",
        align: "start",
        sortable: true,
        value: "emp_code"
      },
      { text: "NAME", value: "name" },
      { text: "EMAIL", value: "email" },
      { text: "PHONE NO", value: "phone_no" },
      { text: "REGION", value: "region" },
      { text: "role", value: "role" },
      { text: "ACTIVE", value: "active" },
      { text: "Actions", value: "actions", sortable: false },

    ]
  }),

  computed: {
    ...mapGetters(["userList", "userStatus", "userStatusResponse"]),
    users: function () {
      return this.userList;
    },
    userStatusmsg: function () {
      return this.userStatus === "success";
    },
    userResponse: function () {
      return this.userStatusResponse;
    }
  },

  watch: {},

  created() {
    this.fetchUsers();
  },

  methods: {
    ...mapActions(["fetchUsers"]),

    editUser(item) {
      const id = item.id;
      //  router.push({ name: 'ProductGroupEdit', params: { productgroupId: 123 }})
      router.push({ path: `/user/edit/${id}` });
    }
  }
};
</script>
